import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Compass, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { WaitlistDialog } from './WaitlistDialog';
import { useLanguage } from '../contexts/LanguageContext';
import { offeringsCopy } from '../data/translations/offerings';
import { useScreenInit } from '../useScreenInit.js';
const LOGO_ICON = 'https://cdn.magicpatterns.com/uploads/kWRktVv4YzBL2Ep7rCMN6b/logo-ster-transparant.png';
export function OfferingsSection() {
  const {
    language
  } = useLanguage();
  const copy = offeringsCopy[language];
  const screenInit = useScreenInit();
  const [waitlistOpen, setWaitlistOpen] = useState<boolean>(screenInit?.waitlistOpen ?? false);
  return <section id="offerings" className="surface-a blend-top relative py-24" data-id="element-154" data-mp="1e722sa4ado9w">
      {/* Decorative compass marks */}
      <div className="absolute top-20 left-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-155" data-mp="ll0syp9jtyju">
        <img src={LOGO_ICON} alt="" className="w-8 h-8" data-id="element-156" data-mp="3vperwrla69ev" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-157" data-mp="3kt0wkvug1jr">
        <img src={LOGO_ICON} alt="" className="w-10 h-10" data-id="element-158" data-mp="8bj5vx0cy2dx" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-159" data-mp="8cb0p5m4rw35">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-160" data-mp="d9koyhxsa1pe">
          <h2 className="font-serif text-4xl md:text-5xl text-ink-900 mb-4" data-id="element-161" data-mp="3gtf9oo4gisw0">
            {copy.heading}
          </h2>
          <p className="text-bronze-600 text-lg font-medium tracking-wide uppercase" data-id="element-162" data-mp="3qpimqp0ukbxq">
            {copy.eyebrow}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch" data-id="element-163" data-mp="10zezgsumre6h">
          {/* 1-on-1 Coaching */}
          <Card hover className="h-full flex flex-col items-center text-center border-t-4 border-t-bronze-400" data-id="element-164" data-mp="15xghrbk8f9gw">
            <div className="w-16 h-16 rounded-full bg-bronze-400/10 flex items-center justify-center mb-6 text-bronze-400" data-id="element-165" data-mp="bcb4qrjb7ynm">
              <Compass size={32} strokeWidth={1.5} data-id="element-166" data-mp="q8aes7pzc8ve" />
            </div>
            <h3 className="font-serif text-2xl text-ink-900 mb-2" data-id="element-167" data-mp="laicqkvmf6dh">
              {copy.oneOnOne.title}
            </h3>
            <p className="text-bronze-600 font-medium mb-6 italic" data-id="element-168" data-mp="3tp94axc6wph9">
              {copy.oneOnOne.tagline}
            </p>
            <p className="text-ink-600 mb-8 flex-grow" data-id="element-169" data-mp="3osimo5kqlltq">
              {copy.oneOnOne.description}
            </p>
            <Button variant="outline" href="#journey" className="w-full mt-auto" data-id="element-170" data-mp="7bsf944w34ol">
              {copy.oneOnOne.cta}
            </Button>
          </Card>

          {/* Retreats */}
          <Card hover className="h-full flex flex-col items-center text-center border-t-4 border-t-bronze-400" data-id="element-171" data-mp="3ay9gw0kcfnq3">
            <div className="w-16 h-16 rounded-full bg-bronze-400/10 flex items-center justify-center mb-6 text-bronze-400" data-id="element-172" data-mp="1lifbolvwsglw">
              <Users size={32} strokeWidth={1.5} data-id="element-173" data-mp="1q9f69khk2ml8" />
            </div>
            <h3 className="font-serif text-2xl text-ink-900 mb-2" data-id="element-174" data-mp="1bk9ak6hxfei3">
              {copy.group.title}
            </h3>
            <p className="text-bronze-600 font-medium mb-6 italic" data-id="element-175" data-mp="1gj2mhuhkexg5">
              {copy.group.tagline}
            </p>
            <p className="text-ink-600 mb-8 flex-grow" data-id="element-176" data-mp="248n5uehmrwpy">
              {copy.group.description}
            </p>
            <Button variant="outline" className="w-full mt-auto" onClick={() => setWaitlistOpen(true)} data-id="element-177" data-mp="296os18acsc5n">
              {copy.group.cta}
            </Button>
          </Card>
        </div>
      </div>

      <WaitlistDialog open={waitlistOpen} onClose={() => setWaitlistOpen(false)} data-id="element-178" data-mp="jt36xg2zyyo2" />
    </section>;
}